import { render, staticRenderFns } from "./CaseFileUpload.vue?vue&type=template&id=4e3cd144&scoped=true&"
import script from "./CaseFileUpload.vue?vue&type=script&lang=js&"
export * from "./CaseFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./CaseFileUpload.vue?vue&type=style&index=0&id=4e3cd144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3cd144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VContainer,VRow,VTextField})
